/**
 * The chips a documents field splits its detail-header notice into (see `document-notices.util.ts`).
 * One chip per kind, each with its own colour, instead of one yellow "N document(en) wachten" that
 * lumped an expired document in with one that is merely waiting for review.
 */
export const DocumentNoticeKindEnum = <const>{
  /** Verlopen or afgekeurd — red. */
  Blocked: 'blocked',
  /** Nothing (usable) uploaded yet: no record, no file, or required data missing — yellow. */
  Missing: 'missing',
  /** Valid today, expires within EXPIRING_SOON_DAYS — yellow. */
  Expiring: 'expiring',
  /** Uploaded, waiting for a reviewer — blue. */
  InReview: 'in-review',
};
export type DocumentNoticeKind = (typeof DocumentNoticeKindEnum)[keyof typeof DocumentNoticeKindEnum];

/** One document as a line in a chip's hover card, plus the chip it belongs in. */
export interface DocumentNoticeItem {
  kind: DocumentNoticeKind;
  /** "NIWO — verlopen" */
  line: string;
  /** Blocked because a reviewer rejected it (not because it expired) — only decides the chip's wording. */
  rejected?: boolean;
}
